import { render } from "./PositionDocumentAssessment.vue?vue&type=template&id=4dfb3a62"
import script from "./PositionDocumentAssessment.vue?vue&type=script&lang=ts"
export * from "./PositionDocumentAssessment.vue?vue&type=script&lang=ts"
script.render = render

export default script